module.exports = __webpack_public_path__ + "img/antes_despues_227.cd7ac93a.png";